export const selectBusiness = state => state.business;
export const selectBusinessQueryOptions = state => {
  const { options } = selectBusiness(state);
  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options;
};
// Business metrics by period selectors
export const selectBusinessMetricsByPeriodList = state =>
  selectBusiness(state).metricsByPeriod.items;
export const selectBusinessMetricsByPeriodCount = state =>
  selectBusiness(state).metricsByPeriod.count;
// Business metrics resume selectors
export const selectBusinessMetricsResumeList = state =>
  selectBusiness(state).resume.items;
export const selectBusinessMetricsResumeCount = state =>
  selectBusiness(state).resume.count;
